import React, { useState, useEffect } from 'react'

import RequestService from 'services/request.service'

import MultiSelectDropdown from 'components/formElements/MultiSelectDropdown'

type EditionResponse = {
  editioncode: string
  editionname: string
  mtgoCode: string | null
}

type Props = {
  disabled?: boolean
  style?: React.CSSProperties
  value?: string[]
  header?: string
  onChange: (values: any[]) => void
}

const SetDropdown = ({ value, onChange, disabled, header }: Props) => {
  const [selectedOptions, setSelectedOptions] = useState(value ?? new Array<string>())
  const [options, setOptions] = useState(new Array<{ label: string; value: any }>())

  useEffect(() => {
    RequestService.get<EditionResponse[]>(`/api/cards/editions/`)
      .then(editions => {
        const options = editions.map(res => ({
          label: `${res.editionname} (${res.editioncode.toLocaleUpperCase()})`,
          searchString: `${res.editionname} (${res.editioncode.toLocaleUpperCase()})`,
          value: res.editioncode,
        }))

        setOptions(options)
      })
      .catch(err => console.error(err))
  }, [])

  // Used to reset the form
  useEffect(() => {
    if (!value || !value.length) setSelectedOptions([])
  }, [value])

  const handleChange = (selectedOptions: any) => {
    setSelectedOptions(selectedOptions)
    onChange(selectedOptions)
  }

  return (
    <MultiSelectDropdown
      searchable
      disabled={disabled}
      placeholder="Editions"
      onChange={handleChange}
      options={options}
      value={selectedOptions}
      header={header || undefined}
    />
  )
}

export default SetDropdown
